/* istanbul ignore file -- api file */
import { fetchGraphql } from '@ori/fetching';

import type { SearchPreviewQuery, SearchPreviewQueryVariables } from '../models/graphql-types/net';
import { searchPreviewQuery } from '../queries-net';
import type { GetSearchPreviewDataParams } from './types';

/**
 * Fetch function that fetches search preview data
 */
export const getSearchPreviewData = async ({ graphQlNetUrl, query, limit, headers }: GetSearchPreviewDataParams) => {
  const data = await fetchGraphql<SearchPreviewQuery, SearchPreviewQueryVariables>({
    query: searchPreviewQuery,
    url: graphQlNetUrl,
    variables: {
      query,
      limit,
    },
    headers,
    timeout: 10000,
  });

  return data;
};
